/**
 * Per-route adire corner blooms — mirrors ZZAI Website handoff app.jsx adireMap.
 */
(function () {
  'use strict';

  const FLAVOR_FROM_HANDLE = [
    ['zobo', 'zobo'],
    ['chapman', 'chapman'],
    ['tamtam', 'tamtam'],
    ['obi', 'obi'],
    ['mixed', 'mixed'],
    ['variety', 'mixed'],
  ];

  function flavorFromHandle(handle) {
    if (!handle) return null;
    const h = String(handle).toLowerCase();
    for (let i = 0; i < FLAVOR_FROM_HANDLE.length; i += 1) {
      if (h.includes(FLAVOR_FROM_HANDLE[i][0])) return FLAVOR_FROM_HANDLE[i][1];
    }
    return null;
  }

  /** @returns {{ key: string, pos: string } | null} */
  function resolveSpec(main) {
    if (!main) return null;
    const tpl = main.dataset.template || '';
    const suffix = main.dataset.templateSuffix || '';
    const page = main.dataset.pageHandle || '';
    const product = main.dataset.productHandle || '';

    if (tpl === 'index') return null;

    if (tpl === 'collection') return { key: 'story', pos: 'br' };
    if (tpl === 'cart') return { key: 'story', pos: 'tl' };

    if (tpl === 'product') {
      if (suffix === 'gift-subscription' || product === 'zzai-gift-subscription') return null;
      if (suffix === 'gift-card' || product === 'zzai-gift-card' || product.includes('gift-card')) return null;
      const sku = flavorFromHandle(product);
      return { key: sku || 'story', pos: 'r' };
    }

    if (tpl === 'page') {
      if (page === 'bundle') return { key: 'mixed', pos: 'tr' };
      if (page === 'subscribe') return { key: 'story', pos: 'tr' };
      if (page === 'gift') return { key: 'story', pos: 'tl' };
      if (page === 'our-story' || page === 'story') return { key: 'story', pos: 'tr' };
      if (page === 'reviews') return { key: 'story', pos: 'tr' };
      if (page === 'find-us') return { key: 'story', pos: 'tl' };
      if (page === 'wholesale') return { key: 'story', pos: 'tl' };
      if (page === 'contact' || page === 'shipping-returns' || page === 'track-order' || page === 'account') {
        return { key: 'story', pos: 'tl' };
      }
      if (suffix === 'bundle') return { key: 'mixed', pos: 'tr' };
      if (suffix === 'subscribe') return { key: 'story', pos: 'tr' };
      if (suffix === 'gift') return { key: 'story', pos: 'tl' };
      if (suffix === 'our-story') return { key: 'story', pos: 'tr' };
      if (suffix === 'find-us') return { key: 'story', pos: 'tl' };
      if (suffix === 'wholesale') return { key: 'story', pos: 'tl' };
      return { key: 'story', pos: 'tr' };
    }

    return null;
  }

  function inject() {
    const main = document.getElementById('MainContent');
    if (!main || !main.classList.contains('page')) return;

    main.querySelectorAll('.page-adire').forEach((n) => n.remove());

    const spec = resolveSpec(main);
    if (!spec) return;

    const el = document.createElement('div');
    el.className = 'page-adire ' + spec.key;
    el.dataset.pos = spec.pos;
    el.setAttribute('aria-hidden', 'true');
    main.prepend(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  document.addEventListener('shopify:section:load', inject);
})();
